import React from 'react'
import { RowActionList } from '../../../legacy-design-system/grid'
import { ModifyAttackEventsTagsAction } from './tag-action'
import { AttackEventRowMoreAction } from './attack-event-row-action-more'
import { PureQueryOptions } from 'apollo-client'
import { AttackEvent } from '../shared'

export interface RouteActionProps {
  organizationUuid: string
  rowData: AttackEvent
  isFreemium: boolean
  isRowHovered: boolean
  refetchQueries: PureQueryOptions[]
  refresh: () => Promise<any>
}

export function AttackEventRowActionList({
  organizationUuid,
  rowData,
  isFreemium,
  isRowHovered,
  refetchQueries,
  refresh,
  refreshGridData
}: RouteActionProps & {
  refreshGridData: () => void
}) {
  const {
    id,
    displayName,
    sourceIP,
    application,
    url,
    type,
    hasExclusion,
    tags,
    sourceName,
    userInput,
    ruleUuid
  } = rowData
  const { id: applicationID, role, name, language } = application

  return (
    <RowActionList>
      <ModifyAttackEventsTagsAction
        organizationUuid={organizationUuid}
        applicationRole={role}
        attackEvents={[
          {
            id,
            tags
          }
        ]}
        refreshGridData={refreshGridData}
      />
      <AttackEventRowMoreAction
        organizationID={organizationUuid}
        refresh={refresh}
        refetchQueries={refetchQueries}
        isFreemium={isFreemium}
        isRowHovered={isRowHovered}
        rowData={{
          id,
          displayName,
          sourceIP,
          application: { id: applicationID, role, name, language },
          url,
          type,
          hasExclusion,
          sourceName,
          userInput: userInput
            ? {
                name: userInput.name,
                type: userInput.type
              }
            : undefined,
          ruleUuid
        }}
      />
    </RowActionList>
  )
}
